import { render } from "./BaseButton.vue?vue&type=template&id=66cd683d&scoped=true"
const script = {}

import "./BaseButton.vue?vue&type=style&index=0&id=66cd683d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66cd683d"]])

export default __exports__